import axios from 'axios';
export var tokenKey = '_auth';
var axiosInstance = axios.create();
axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
axiosInstance.interceptors.request.use(function (config) {
    var token = localStorage.getItem(tokenKey);
    if (token && config.headers) {
        config.headers.Authorization = "Bearer ".concat(token);
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
export default axiosInstance;
